import "./FormTab.scss";
import activeType from "./../../assets/images/activeType.svg";
interface FormTabProps {
  tabName: string;
  isActive: boolean;
  setClientType?: () => void;
}
const FormTab = ({ tabName, isActive, setClientType }: FormTabProps) => {
  return (
    <div
      className={`form-tab-comtainer ${isActive ? "active-tab" : ""}`}
      onClick={setClientType}
    >
      {isActive ? <img src={activeType}></img> :
      <span className="no-active-type"></span>}
      {tabName}
    </div>
  );
};

export default FormTab;
